import { forwardRef, ReactNode } from 'react';
import { Stack, SxProps, Theme } from '@mui/material';
import { useSlotContext } from '@upheal/design-system/utils/useSlotContext';

import { ModalSizingVariant, paddingValues } from './Modal.styleUtils';

const contentPaddingValues = {
    sm: { ...paddingValues.sm, py: 3 },
    md: paddingValues.md,
} as const satisfies Record<ModalSizingVariant, { px: number; py: number }>;

interface ModalContentProps {
    children: ReactNode;
    sx?: SxProps<Theme>;
    scrollable?: boolean;
}

export const ModalContent = forwardRef<HTMLDivElement, ModalContentProps>(
    function ModalContent({ children, sx, scrollable }, ref) {
        const { sizing = 'md' } = useSlotContext({}, 'modal');

        return (
            <Stack
                ref={ref}
                sx={{
                    ...contentPaddingValues[sizing],
                    ...(scrollable ? { overflowY: 'auto' } : {}),
                    ...sx,
                }}
            >
                {children}
            </Stack>
        );
    },
);
